(function () {
  // ── On-site behavior tracking ──────────────────────────────────────────
  // Separate from the Meta/GoKwik funnel pixel (ViewContent/AddToCart/etc,
  // fired by the Shopify Web Pixel). This is engagement data: which cards
  // get clicked, which collections get browsed, wishlist adds, cart drawer
  // opens, PDP section engagement, brand/policy views.
  //
  // Performance contract: never one network call per interaction. Events
  // queue in memory and flush as a single batched request via sendBeacon
  // (survives page unload/navigation, doesn't block anything) on an
  // interval + on page-hide. No scroll listeners — impressions/section
  // engagement use IntersectionObserver, which is native-cheap.
  var ENDPOINT = 'https://dashboard.croscrow.com/track/site-events';
  var FLUSH_MS = 5000;
  var SID_KEY = 'cc_sid';

  function sid() {
    try {
      var s = sessionStorage.getItem(SID_KEY);
      if (!s) { s = 'sid_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10); sessionStorage.setItem(SID_KEY, s); }
      return s;
    } catch (e) { return 'sid_nosession'; }
  }

  var queue = [];

  function track(event, data) {
    try {
      queue.push(Object.assign({
        event: event,
        session_id: sid(),
        page: location.pathname,
        ts: Date.now(),
      }, data || {}));
      if (queue.length >= 20) flush(); // safety cap — don't let one page build an unbounded queue
    } catch (e) {}
  }

  function flush() {
    if (!queue.length) return;
    var batch = queue.splice(0, queue.length);
    var body = JSON.stringify({ events: batch });
    // fetch(keepalive) only, not sendBeacon. Confirmed directly (and it
    // matches sendBeacon's long-documented unreliability in mobile in-app
    // WebViews, e.g. Instagram's — most of this store's traffic): sendBeacon
    // to a cross-origin endpoint with a JSON body silently fails delivery
    // here while reporting success (sendBeacon's return value only means
    // "the browser accepted it into its queue," never "it was delivered" —
    // there is no completion callback, so a flush() that trusted that
    // return value had no way to know most sends were being dropped).
    // fetch's own keepalive flag exists specifically so a request can
    // outlive page-unload/navigation, same guarantee sendBeacon was meant
    // to provide, without that failure mode.
    try {
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true }).catch(function () {});
    } catch (e) {}
  }

  setInterval(flush, FLUSH_MS);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);

  // Fire once per element the first time it's actually seen (not just
  // present in the DOM) — used for card impressions and PDP section
  // engagement. `dataFn(el)` computes the event payload lazily per element.
  function observeOnce(selector, event, dataFn, opts) {
    var els = document.querySelectorAll(selector);
    if (!els.length || !('IntersectionObserver' in window)) return;
    var seen = new WeakSet();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || seen.has(entry.target)) return;
        seen.add(entry.target);
        io.unobserve(entry.target);
        track(event, dataFn(entry.target) || {});
      });
    }, Object.assign({ threshold: 0.5 }, opts || {}));
    els.forEach(function (el) { io.observe(el); });
    return io;
  }

  // Page-level dwell time — elapsed active-ish time on this page, sent once
  // on unload. Doesn't attempt to subtract idle/background time; a rough
  // "time on page" is what's useful here, not lab-grade attention tracking.
  function trackDwellOnUnload(event, dataFn) {
    var start = performance.now();
    var sent = false;
    function send() {
      if (sent) return; sent = true;
      track(event, Object.assign({ value: Math.round(performance.now() - start) }, dataFn() || {}));
      flush();
    }
    window.addEventListener('pagehide', send);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') send(); });
  }

  window.ccTrack = track;
  window.ccTrackObserveOnce = observeOnce;
  window.ccTrackDwellOnUnload = trackDwellOnUnload;
})();
